import React, { useCallback, useContext } from 'react';
import { NavigationBlockingContext } from '../context/NavigationBlockingContextProvider';

// Wraps any onClick-style callback so that registered navigation blockers must
// approve before the callback is invoked.  Drop-in replacement for an onClick prop.
export const useBlockingCallback = <Args extends unknown[]>(
	callback: ( ( ...args: Args ) => void ) | undefined
): ( ( ...args: Args ) => void ) | undefined => {
	const ctx = useContext( NavigationBlockingContext );

	const blocked = useCallback(
		async ( ...args: Args ) => {
			if ( !ctx || !ctx.hasBlockers() ) {
				callback?.( ...args );
				return;
			}
			// For click handlers, args[0] is the mouse event
			const allowed = await ctx.executeBlockers( args[ 0 ] as React.MouseEvent );
			if ( allowed ) {
				callback?.( ...args );
			}
		},
		[ ctx, callback ]
	);

	return callback === undefined
		? undefined
		: ( blocked as ( ...args: Args ) => void );
};
